import styled from "styled-components";

import DropdownMenuGroup from "../DropdownMenuGroup/DropdownMenuGroup";
import DropdownMenuTextLink from "../DropdownMenuTextLink/DropdownMenuTextLink";
import NavbarDropdown from "../NavbarDropdown/NavbarDropdown";
import Trigger from "../Trigger/Trigger";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import { ShopDropdownIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import { useFlags } from "launchdarkly-react-client-sdk";
import createAbsolutePath from "createAbsolutePath";

const NavbarShopDropdownContainer = styled.div`
  display: flex;
`;

const ShowroomGroup = () => (
  <DropdownMenuGroup>
    <DropdownMenuTextLink
      to={createAbsolutePath("/ra/showroom/collections")}
      message={messages.looks}
      id={ShopDropdownIds.ShopOptionLooks}
    />
    <DropdownMenuTextLink
      to={createAbsolutePath("/ra/showroom/styleboards")}
      message={messages.styleboards}
      id={ShopDropdownIds.ShopOptionStyleBoards}
    />
    <DropdownMenuTextLink
      to={createAbsolutePath("/ra/showroom/styleboards/add")}
      message={messages.createStyleboard}
      id={ShopDropdownIds.ShopOptionCreateStyleboard}
    />
  </DropdownMenuGroup>
);

const NavbarShopDropdown = () => {
  const { virtualShowroom } = useFlags();

  return (
    <NavbarShopDropdownContainer>
      <NavbarDropdown
        trigger={
          <Trigger label={messages.shop} id={ShopDropdownIds.ShopTrigger} />
        }
      >
        <DropdownMenuGroup>
          <DropdownMenuTextLink
            message={messages.browseCatalog}
            id={ShopDropdownIds.ShopOptionBrowseCatalog}
            to={createAbsolutePath("/r/products")}
          />
        </DropdownMenuGroup>
        {virtualShowroom && <ShowroomGroup />}
      </NavbarDropdown>
    </NavbarShopDropdownContainer>
  );
};
export default NavbarShopDropdown;
